import { Navigate, useLocation } from "react-router-dom";
import AuthLoadingScreen from "./AuthLoadingScreen";
import { useAuth } from "./useAuth";

const RequireAuth = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
          fromHash: window.location.hash || "",
        }}
      />
    );
  }

  return children;
};

export default RequireAuth;
